// Warning: 用后端获取 !!!!
export var E_ChargeMode;
(function (E_ChargeMode) {
    // 未知
    E_ChargeMode["UNKNOWN"] = "UNKNOWN";
    // 商业
    E_ChargeMode["COMMERCIAL"] = "COMMERCIAL";
    // 使用
    E_ChargeMode["TRIAL"] = "TRIAL";
    // 免费
    E_ChargeMode["FREE"] = "FREE";
    // 历史
    E_ChargeMode["HISTORICAL"] = "HISTORICAL";
    // 内置
    E_ChargeMode["INTERNAL"] = "INTERNAL";
    // 测试
    E_ChargeMode["BETA"] = "BETA";
    // 合作推广
    E_ChargeMode["COOPERATIVE"] = "COOPERATIVE";
    // 断约
    E_ChargeMode["NOT_RENEW"] = "NOT_RENEW";
})(E_ChargeMode || (E_ChargeMode = {}));
export var E_PackageStatus;
(function (E_PackageStatus) {
    E_PackageStatus["Active"] = "Active";
    E_PackageStatus["Disable"] = "Disable";
})(E_PackageStatus || (E_PackageStatus = {}));
export var E_PrivilegeType;
(function (E_PrivilegeType) {
    E_PrivilegeType["COMPANY"] = "company";
    E_PrivilegeType["TRIAL"] = "trial";
})(E_PrivilegeType || (E_PrivilegeType = {}));
